const WS_TOKEN_STORAGE_KEY = 'taogo-ws-register-token';

/** URL 是否携带 WhatsApp 短期 token（不含 sessionStorage） */
export function readWsTokenFromSearchParams(searchParams) {
  const source =
    searchParams instanceof URLSearchParams
      ? searchParams
      : new URLSearchParams(searchParams);
  return (
    source.get('wstoken')?.trim() ||
    source.get('token')?.trim() ||
    source.get('ws_token')?.trim() ||
    ''
  );
}

/**
 * 仅 /loginfromws、/registerfromws：URL 优先，否则用 sessionStorage（WhatsApp 内跳转丢参）。
 */
export function resolveWsTokenForWsRoute(searchParams) {
  const fromUrl = readWsTokenFromSearchParams(searchParams);
  if (fromUrl) {
    sessionStorage.setItem(WS_TOKEN_STORAGE_KEY, fromUrl);
    return fromUrl;
  }
  return sessionStorage.getItem(WS_TOKEN_STORAGE_KEY)?.trim() || '';
}

/**
 * @deprecated 请区分场景：登录页用 {@link readWsTokenFromSearchParams}；
 * WS 专页用 {@link resolveWsTokenForWsRoute}。
 */
export function resolveWsToken(searchParams) {
  return resolveWsTokenForWsRoute(searchParams);
}

export function persistWsTokenFromWindow() {
  if (typeof window === 'undefined') {
    return;
  }
  const token = readWsTokenFromSearchParams(window.location.search);
  if (token) {
    sessionStorage.setItem(WS_TOKEN_STORAGE_KEY, token);
  }
}

export function clearWsToken() {
  sessionStorage.removeItem(WS_TOKEN_STORAGE_KEY);
}

/** 带 WhatsApp 短期 token 的登录/注册路径（避免链式跳转丢参） */
export function buildLoginFromWsPath(wsToken) {
  const t = (wsToken || '').trim();
  if (!t) {
    return '/login';
  }
  return `/loginfromws?wstoken=${encodeURIComponent(t)}`;
}

export function buildRegisterFromWsPath(wsToken) {
  const t = (wsToken || '').trim();
  if (!t) {
    return '/register';
  }
  return `/registerfromws?wstoken=${encodeURIComponent(t)}`;
}

export function isWsTokenError(message) {
  return (message || '').toLowerCase().includes('invalid or expired token');
}

export function isWsMemberNotFoundError(message) {
  return (message || '').toLowerCase().includes('member not found');
}

export function isWsPhoneRequiredError(message, code) {
  if (code === 'WS_PHONE_REQUIRED') {
    return true;
  }
  const m = (message || '').toLowerCase();
  return m.includes('sms verification') || m.includes('verification code');
}
